<template>
  <div class="w-5/6 ml-auto mr-auto vx-col">
    <span>
      <b v-if="territoryId != null">Edit Territory</b>
      <b v-else>Create Territory</b>
    </span>
    <div class="mb-6 vx-row">
      <div class="w-full vx-col">
        <label class="vs-input--label">Territory Area</label>
        <multiselect
          v-model="territoryAreaSelected"
          :options="territoryAreaOptions"
          placeholder="Type to search"
          label="name"
          track-by="code"
          :max-height="125"
        >
          <span slot="noResult">Oops! No data found</span>
          <template slot="singleLabel" slot-scope="props">
            <span class="option__desc">
              <span class="option__title"
              >{{ props.option.code }} {{ props.option.name }}</span
              >
            </span>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title"
              >{{ props.option.code }} {{ props.option.name }}</span
              >
            </div>
          </template>
        </multiselect>
        <span
          class="text-sm text-danger"
          v-show="errors.has('TerritoryArea')"
        >{{ errors.first("TerritoryArea") }}</span
        >
      </div>
    </div>
    <div class="mb-6 vx-row" v-if="territoryId != null">
      <div class="w-full vx-col">
        <vs-input disabled class="w-full" label="Code" v-model="data.code"/>
      </div>
    </div>
    <div class="mb-6 vx-row" v-else>
      <div class="w-full vx-col">
        <vs-input
          class="w-full"
          name="Code"
          label="Code"
          v-model="data.code"
          v-validate="'required'"
        />
        <span class="text-sm text-danger" v-show="errors.has('Code')">{{
            errors.first("Code")
          }}</span>
      </div>
    </div>
    <div class="mb-6 vx-row" v-if="territoryId != null && data.external_code.length > 30">
      <div class="w-full vx-col">
        <vs-input disabled class="w-full" label="External Code" v-model="data.external_code"/>
      </div>
    </div>
    <div class="mb-6 vx-row" v-else>
      <div class="w-full vx-col">
        <vs-input
          class="w-full"
          name="External Code"
          label="External Code"
          v-model="data.external_code"
          v-validate="'required'"
        />
        <span class="text-sm text-danger" v-show="errors.has('ExternalCode')">{{
            errors.first("ExternalCode")
          }}</span>
      </div>
    </div>
    <div class="mb-6 vx-row">
      <div class="w-full vx-col">
        <vs-input
          class="w-full"
          label="Name"
          v-validate="'required'"
          name="Name"
          v-model="data.name"
        />
        <span class="text-sm text-danger" v-show="errors.has('Name')">{{
            errors.first("Name")
          }}</span>
      </div>
    </div>
    <div class="mb-6 vx-row">
      <div class="w-full vx-col">
        <vs-input
          class="w-full"
          label="Description"
          name="Description"
          v-model="data.description"
        />
      </div>
    </div>
    <address-component
      :data="data.address"
      @data="setDataAddress"
    ></address-component>

    <div class="mb-6 vx-row">
      <div class="w-full vx-col">
        <vs-input
          class="w-full"
          label="IPAK"
          name="ipak"
          v-model="data.ipak"
        />
<!--        <span class="text-sm text-danger" v-show="errors.has('IPAK')">{{-->
<!--            errors.first("Code")-->
<!--          }}</span>-->
      </div>
    </div>

    <div class="mb-6 vx-row">
      <div class="w-full vx-col">
        <vs-input
          class="w-full"
          label="PBF"
          name="pbf"
          v-model="data.pbf"
        />
<!--        <span class="text-sm text-danger" v-show="errors.has('PBF')">{{-->
<!--            errors.first("Code")-->
<!--          }}</span>-->
      </div>
    </div>

    <div class="mb-6 vx-row">
      <div class="w-full vx-col">
        <vs-input
          class="w-full"
          label="CDOB"
          name="cdob"
          v-model="data.cdob"
        />
      </div>
    </div>

    <div class="mb-6 vx-row">
      <div class="w-full vx-col">
        <vs-input
          class="w-full"
          label="NITKU"
          maxlength="6"
          name="nitku"
          v-model="data.nitku"
          @keypress="isNumber($event)"
        />
      </div>
    </div>

     <div class="mb-6 vx-row">
      <div class="w-full vx-col">
        <label class="vs-input--label">Principal</label>
        <multiselect
          class="selectExample"
          v-model="principal.selected"
          :options="principal.options"
          :multiple="false"
          :allow-empty="false"
          :group-select="false"
          :max-height="160"
          :limit="4"
          placeholder=" Type to search"
          label="name"
        >
          <template slot="singleLabel" slot-scope="dt">
            <span class="option__desc">
              <span class="option__title">{{ dt.option }}</span>
            </span>
          </template>

          <template slot="option" slot-scope="dt">
            <div class="option__desc">
              <span class="option__title">{{ dt.option }}</span>
            </div>
          </template>
        </multiselect>
      </div>
    </div>

    <div class="vx-row">
      <div class="w-full vx-col">
        <vs-button class="mb-2 mr-3" @click="handleSubmit">Submit</vs-button>
        <vs-button
          class="mt-2 ml-4"
          type="border"
          color="danger"
          v-on:click="handleClose"
        >Close
        </vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import AddressComponent from "@/components/master/Address";

export default {
  components: {
    AddressComponent,
  },
  props: {
    territoryId: {
      type: Number,
    },
    baseUrl: {
      type: String,
    },
  },

  data() {
    return this.initialState();
  },
  methods: {
    initialState() {
      return {
        territoryAreaOptions: [],
        territoryAreaSelected: null,
        principal: {
          options: ["MIX", "ULI", "JTI", "FFI", "UFS"],
          selected: null
        },
        data: {
          territoryAreaId: null,
          code: "",
          name: "",
          external_code: "",
          description: "",
          ipak: "",
          pbf: "",
          cdob: "",
          nitku: "",
          principal: "",
          address: {
            address: "",
            postalCode: "",
            countryName: "",
            provinceName: "",
            cityName: "",
            districtName: "",
            subdistrictName: "",
          },
        },
      };
    },
    handleSubmit() {
      this.errors.clear();
      let hasError = false;

      if (!this.data.territoryAreaId) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Territory Area field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }
      if (!this.data.code) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Code field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }
      if (!this.data.external_code) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The External Code field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }
      if (!this.data.name) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Name field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (!this.data.address.countryName) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Country field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (!this.data.address.provinceName) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Province field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (!this.data.address.cityName) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The City field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (!this.data.address.districtName) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The District field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (!this.data.address.subdistrictName) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Subdistrict field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (!this.data.address.address) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Address field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (!this.data.address.postalCode) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Postal Code field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (this.data.nitku != "" && this.data.nitku.length < 6) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "NITKU must length 6",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (this.principal.selected == null) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Principal field is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        hasError = true;
      }

      if (hasError) return;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          if (this.territoryId) {
            this.putData();
          } else {
            this.postData();
          }
        }
      });
    },
    paramData() {
      return {
        territory_area_id: this.data.territoryAreaId,
        code: this.data.code,
        external_code: this.data.external_code,
        name: this.data.name,
        description: this.data.description,
        country: this.data.address.countryName,
        province: this.data.address.provinceName,
        city: this.data.address.cityName,
        district: this.data.address.districtName,
        sub_district: this.data.address.subdistrictName,
        address: this.data.address.address,
        postal_code: this.data.address.postalCode,
        ipak: this.data.ipak,
        pbf: this.data.pbf,
        cdob: this.data.cdob,
        nitku: this.data.nitku,   
        principal: this.principal.selected,       
      };
    },
    postData() {
      this.$http
        .post(this.baseUrl, this.paramData())
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "New Territory Created",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    putData() {
      this.$http
        .put(this.baseUrl + "/" + this.territoryId, this.paramData())
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Territory Updated",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    getData() {
      this.$vs.loading();
      if (this.territoryId) {
        this.$http
          .get(this.baseUrl + "/" + this.territoryId)
          .then((resp) => {
            this.$vs.loading.close();
            if (resp.code == 200) {
              this.data.territoryAreaId = resp.data.territory_area_id;
              this.data.code = resp.data.code;
              this.data.external_code = resp.data.external_code;
              this.data.name = resp.data.name;
              this.data.description = resp.data.description;
              this.data.address.address = resp.data.territory_geo.address;
              this.data.address.postal_code = resp.data.territory_geo.postal_code;
              this.data.address.countryName = resp.data.territory_geo.country;
              this.data.address.provinceName = resp.data.territory_geo.province;
              this.data.address.cityName = resp.data.territory_geo.city;
              this.data.address.districtName = resp.data.territory_geo.district;
              this.data.address.subdistrictName = resp.data.territory_geo.sub_district;
              this.data.ipak = resp.data.ipak;
              this.data.pbf = resp.data.pbf;
              this.data.cdob = resp.data.cdob;
              this.data.nitku = resp.data.nitku;
              this.principal.selected = resp.data.principal;
            
              this.$http
                .get(this.baseUrl + "-area/" + this.data.territoryAreaId)
                .then((resp) => {
                  this.$vs.loading.close();
                  if (resp.code == 200) {
                    this.territoryAreaSelected = resp.data;
                  } else {
                    this.$vs.notify({
                      color: "danger",
                      title: "Error",
                      text: resp.message,
                      position: "top-right",
                      iconPack: "feather",
                      icon: "icon-x-circle",
                    });
                  }
                })
                .catch((error) => {
                  this.$vs.loading.close();
                  console.log(error);
                });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
            }
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log(error);
          });
      }
    },
    getAllDataTerritoryArea() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl + "-area", {
          params: {
            order: "code",
            type: "Sales",
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.territoryAreaOptions = resp.data.records;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
    setDataAddress(val) {
      this.data.address = val;
    },
    getCode() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/setting/master-number-code/ST")
        .then((resp) => {
          if (resp.status == "success") {
            this.data.code = resp.data;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.getAllDataTerritoryArea();
    if (this.territoryId) {
      this.getData();
    } else {
      this.getCode();
    }
  },
  computed: {},
  watch: {
    territoryId(v) {
      if (v) {
        this.getData();
      } else {
        Object.assign(this.$data, this.initialState());
      }
      this.getAllDataTerritoryArea();
    },
    territoryAreaSelected(val) {
      if (val) {
        this.errors.clear();
        this.data.territoryAreaId = val.id;
      } else {
        this.data.territoryAreaId = null;
      }
    },
  },
};
</script>
